import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthUtilsService } from './auth-utils.service';
import { APP_ROUTES } from '@app/constants';
import { AuthService } from './auth.service';
import { RESPONSE_CODES } from '@app/constants/response-codes.constant';

export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authUtilsService = inject(AuthUtilsService);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error) => {
      if (
        (+error.error?.code === HttpStatusCode.Forbidden ||
          error.error.message?.includes('JWT expired')) ||
        +error.error.code === HttpStatusCode.Unauthorized
      ) {
        error.error.message = 'Session Expired. Please login again.';
        router.navigate([APP_ROUTES.LOGOUT]).then();
      }

      // Access token expired. Go and grab new access token using refresh token and resume the current request with access token.
      if (error.error.code === RESPONSE_CODES.ACCESS_TOKEN_EXPIRED && authService.isAuthenticated()) {
        return authService
          .refreshToken(authUtilsService.getRefreshToken())
          .pipe(
            switchMap((response) => {
              const accessToken = response.data.access_token;
              const refreshToken = response.data.refresh_token;
              authUtilsService.setAccessToken(accessToken);
              authUtilsService.setRefreshToken(refreshToken);

              const newReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${accessToken}`,
                },
              });

              return next(newReq);
            }),
            catchError(error => throwError(() => error))
          );
      }

      return throwError(() => error);
    })
  );
};
